/*
  FSO Müzik Poster stüdyosu — "Spotify Poster Tablosu" ve "Forever Poster Tablosu" (Teeinblue yerine).

  Müşteri fotoğrafını yükler (kartta sürükleyip yakınlaştırarak konumlandırır) ve Spotify şarkı linkini yapıştırır:
  → şarkı adı, sanatçı, süre ve Spotify kodu sunucudan gelir (/spotify); Forever'da sözler de (/muzik/soz, LRCLIB).
    Hepsi elle düzenlenebilir; link yapıştırmadan da yazılabilir.
  → poster tarayıcıda PSD ölçüleriyle anlık çizilir (1000 × 1400 birim = 50×70 cm):
       spotify — fotoğraftan çıkan degrade zemin (koyu ana renk + sol üstte açık parıltı + altta koyulaşma), müzik çalar ekranı
       forever — siyah kemer, sabit "Forever" (Storytelling, vektör), tarih/yıl, fotoğraf (siyah-beyaz ya da renkli), şarkı, sanatçı, sözler
  → sepete eklerken fotoğraf hariç poster (3200×4480 JPEG) + müşterinin fotoğrafı + kırpma bilgisi sunucuya gider
    (/muzik/baski); sunucu 50×70 cm PDF yapar ve fotoğrafı orijinal çözünürlüğünde, yeniden sıkıştırmadan gömer.
    JPEG fotoğraf olduğu gibi gönderilir; yalnız siyah-beyaz, CMYK ya da JPEG olmayan dosyalar tarayıcıda (en çok 16 MP)
    yeniden kodlanır.
  → sipariş özellikleri: _tasarim, _tasarim_pdf, _tasarim_onizleme, _foto, _polaroid ve tasarıma göre metin alanları.

  Kurulum: <div data-fso-muzik><script type="application/json" data-fso-muzik-ayar>{...}</script></div>
  Ayarlar: api, tasarim ('spotify' | 'forever'), form, medya, galeri, renk, kvkk, polaroid, metinler {..}
*/
(function () {
  'use strict';

  var BW = 1000, BH = 1400; // tüm ölçüler bu birimlerde (PSD'den: Spotify 5906 px, Forever 3937 px genişlik)
  var KUTU = { spotify: { x: 161.2, y: 168.1, w: 677.4, h: 677.4 }, forever: { x: 93.2, y: 300.5, w: 813.6, h: 612.1 } };
  var BASKI = [3200, 4480]; // zemin (fotoğraf hariç poster); tuval oluşturulamazsa küçültülür
  var ILERLEME = 0.3715; // Spotify'daki süre çubuğu: şarkının bu oranında durur (PSD'deki konum)
  var YESIL = '#1DB954';
  var HAZIR_PALET = {
    yesil: { ad: 'Yeşil', taban: '#142924', isik: '#EDE07C', derin: '#0C1C18' },
    kahve: { ad: 'Kahverengi', taban: '#2E1E14', isik: '#E8C48E', derin: '#1A100A' },
  };
  // Forever başlığı: Storytelling fontuyla dizilmiş "Forever" kelimesinin çizgileri (font birimleri, y aşağı; HarfBuzz ile
  // kerning uygulanmış). Font dosyası sitede kullanılmaz; yazı sabittir. Mürekkep sınırı PSD'deki başlık kutusuna oturur.
  var FOREVER_YOL = 'M137 -646Q114 -639 95 -626Q76 -613 59 -596Q51 -588 44 -587.5Q37 -587 29 -595Q20 -603 21.5 -610.5Q23 -618 30 -626Q44 -642 61.5 -651.5Q79 -661 98 -669Q136 -684 175.5 -692.5Q215 -701 256 -709Q285 -715 313.5 -719.5Q342 -724 371 -726Q382 -726 393.5 -726.5Q405 -727 419 -722Q411 -715 403.5 -714.5Q396 -714 389 -713Q349 -708 310 -700Q271 -692 233 -683Q209 -679 199 -657Q188 -639 175 -610Q162 -581 148.5 -549.5Q135 -518 122.5 -488Q110 -458 101 -439Q111 -438 120.5 -440.5Q130 -443 139.5 -444.5Q149 -446 158.5 -445.5Q168 -445 179 -439Q162 -433 148 -428Q134 -423 120 -418Q100 -412 89 -399Q78 -386 72 -366Q53 -301 49 -236.5Q45 -172 60 -103Q49 -105 45.5 -111Q42 -117 40 -123Q29 -157 27 -196Q25 -230 24.5 -263Q24 -296 27 -330Q29 -339 27 -344.5Q25 -350 15 -355Q1 -363 0.5 -372Q0 -381 15 -389Q37 -400 46.5 -418.5Q56 -437 63 -458Q68 -473 77.5 -499Q87 -525 98 -552.5Q109 -580 119.5 -605.5Q130 -631 137 -646ZM220 -314Q216 -308 214 -304Q212 -300 210 -295Q212 -292 214 -292Q216 -292 218 -292Q231 -292 241 -287.5Q251 -283 255 -269Q257 -261 262 -260Q267 -259 273 -261Q280 -263 296 -267.5Q312 -272 328 -275.5Q344 -279 356 -280.5Q368 -282 368 -279Q368 -277 357.5 -274Q347 -271 332.5 -267.5Q318 -264 303.5 -261Q289 -258 281 -255Q267 -251 257.5 -245Q248 -239 242 -226Q230 -199 204 -182Q184 -169 169 -176.5Q154 -184 152 -208Q150 -219 153 -229Q156 -239 149 -249Q146 -255 152 -261Q163 -270 168.5 -282.5Q174 -295 182 -307Q190 -321 195 -321.5Q200 -322 220 -314ZM224 -238Q210 -233 202 -233.5Q194 -234 188 -238Q179 -243 177.5 -233Q176 -223 174 -216Q172 -208 171.5 -201Q171 -194 178 -188Q181 -185 185 -187Q189 -189 192 -191Q203 -200 211 -211Q219 -222 224 -238ZM187 -251Q198 -246 206 -246.5Q214 -247 223 -249Q232 -251 233.5 -259.5Q235 -268 234 -274Q232 -282 227 -283.5Q222 -285 216 -284Q203 -281 195 -274Q187 -267 187 -251ZM397 -236Q402 -250 406.5 -260.5Q411 -271 420 -285Q426 -295 434 -301Q442 -307 449 -308.5Q456 -310 461 -306Q466 -302 466 -292Q466 -274 470 -267.5Q474 -261 483.5 -263Q493 -265 508 -273.5Q523 -282 543 -293Q549 -285 548 -284.5Q547 -284 543 -282Q516 -268 499.5 -262.5Q483 -257 474 -258.5Q465 -260 461 -267Q457 -274 456 -285Q455 -291 452.5 -292Q450 -293 447 -291Q444 -289 440.5 -284.5Q437 -280 434 -276Q426 -263 420.5 -251.5Q415 -240 410.5 -228.5Q406 -217 400.5 -205Q395 -193 387 -180Q383 -175 379 -172Q375 -169 369 -171Q357 -174 354 -187Q354 -193 353 -196Q354 -207 354.5 -218Q355 -229 357 -238Q360 -265 366.5 -291Q373 -317 382 -343Q387 -357 394.5 -359Q402 -361 415 -355Q426 -349 421 -336Q411 -318 406 -297.5Q401 -277 396 -256Q394 -251 393 -246.5Q392 -242 397 -236ZM705 -275Q693 -266 678 -254Q663 -242 647 -230Q631 -218 615 -209Q599 -200 585 -197Q569 -193 552 -191.5Q535 -190 523 -206Q517 -213 517 -222Q517 -231 519.5 -240.5Q522 -250 525.5 -259Q529 -268 532 -275Q546 -307 570 -327Q587 -341 603 -330Q612 -324 611.5 -316.5Q611 -309 608 -301Q600 -282 585 -262Q580 -255 573.5 -250.5Q567 -246 558 -248Q545 -251 542 -245.5Q539 -240 539 -230Q539 -219 547 -213Q555 -207 564 -209Q587 -213 603.5 -219Q620 -225 635 -233.5Q650 -242 665.5 -253.5Q681 -265 701 -280Q702 -278 705 -275ZM580 -303Q570 -298 564 -290Q558 -282 558 -271Q576 -283 580 -303ZM902 -264Q877 -247 850 -237Q823 -227 792 -232Q781 -234 776.5 -231Q772 -228 767 -220Q759 -206 750 -192Q741 -178 732 -164Q729 -159 725 -154Q721 -149 717 -144Q712 -139 706.5 -136Q701 -133 694 -135Q678 -141 677 -157Q674 -188 680 -218Q686 -252 698 -284Q707 -304 726 -297Q736 -292 739.5 -286Q743 -280 738 -269Q730 -249 724.5 -229Q719 -209 712 -189Q710 -184 709.5 -178Q709 -172 707 -164Q718 -169 723 -176Q728 -183 733 -190Q748 -213 760 -237.5Q772 -262 774 -291Q776 -311 784 -330Q792 -349 803 -366Q806 -371 809.5 -375Q813 -379 817 -384Q828 -395 837 -388Q844 -384 844 -379Q844 -374 842 -368Q834 -345 822.5 -323.5Q811 -302 800 -280Q796 -272 790 -263Q784 -254 790 -245Q798 -234 808.5 -236.5Q819 -239 829 -241Q849 -244 866 -251.5Q883 -259 902 -264ZM1072 -275Q1060 -266 1045 -254Q1030 -242 1014 -230Q998 -218 982 -209Q966 -200 952 -197Q936 -193 919 -191.5Q902 -190 890 -206Q884 -213 884 -222Q884 -231 886.5 -240.5Q889 -250 892.5 -259Q896 -268 899 -275Q913 -307 937 -327Q954 -341 970 -330Q979 -324 978.5 -316.5Q978 -309 975 -301Q967 -282 952 -262Q947 -255 940.5 -250.5Q934 -246 925 -248Q912 -251 909 -245.5Q906 -240 906 -230Q906 -219 914 -213Q922 -207 931 -209Q954 -213 970.5 -219Q987 -225 1002 -233.5Q1017 -242 1032.5 -253.5Q1048 -265 1068 -280Q1069 -278 1072 -275ZM947 -303Q937 -298 931 -290Q925 -282 925 -271Q943 -283 947 -303ZM1097 -236Q1102 -250 1106.5 -260.5Q1111 -271 1120 -285Q1126 -295 1134 -301Q1142 -307 1149 -308.5Q1156 -310 1161 -306Q1166 -302 1166 -292Q1166 -274 1170 -267.5Q1174 -261 1183.5 -263Q1193 -265 1208 -273.5Q1223 -282 1243 -293Q1249 -285 1248 -284.5Q1247 -284 1243 -282Q1216 -268 1199.5 -262.5Q1183 -257 1174 -258.5Q1165 -260 1161 -267Q1157 -274 1156 -285Q1155 -291 1152.5 -292Q1150 -293 1147 -291Q1144 -289 1140.5 -284.5Q1137 -280 1134 -276Q1126 -263 1120.5 -251.5Q1115 -240 1110.5 -228.5Q1106 -217 1100.5 -205Q1095 -193 1087 -180Q1083 -175 1079 -172Q1075 -169 1069 -171Q1057 -174 1054 -187Q1054 -193 1053 -196Q1054 -207 1054.5 -218Q1055 -229 1057 -238Q1060 -265 1066.5 -291Q1073 -317 1082 -343Q1087 -357 1094.5 -359Q1102 -361 1115 -355Q1126 -349 1121 -336Q1111 -318 1106 -297.5Q1101 -277 1096 -256Q1094 -251 1093 -246.5Q1092 -242 1097 -236Z';
  var FOREVER_SINIR = [0.48, -726.55, 1247.66, 623.55]; // x, y, en, boy (font birimi)
  var FOREVER_KUTU = [386.6, 80.0, 229.9, 115.1]; // PSD: 1522–2427 × 315–768 px (3937 px genişlikte)
  var foreverYolu = null;

  /* ---------- Yazı tipleri ---------- */
  var yaziSozu = null;
  function yaziTipleriniYukle() {
    if (!yaziSozu) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Arimo:wght@400;700&family=Montserrat:wght@300;700&display=swap';
      document.head.appendChild(l);
      var ornek = 'ABCÇĞİÖŞÜabcçğıöşü0123:&';
      yaziSozu = new Promise(function (tamam) { l.onload = tamam; l.onerror = tamam; }).then(function () {
        return Promise.all(['400 40px "Arimo"', '300 40px "Montserrat"', '700 40px "Montserrat"']
          .map(function (f) { return document.fonts.load(f, ornek).catch(function () {}); }));
      });
    }
    return yaziSozu;
  }

  /* ---------- Renk yardımcıları ---------- */
  function hexRgb(h) { var n = parseInt(String(h).slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function rgba(h, a) { var c = hexRgb(h); return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }
  function rgbHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, s = 0, d = mx - mn;
    if (d > 1e-6) {
      s = d / (1 - Math.abs(2 * l - 1));
      if (mx === r) h = ((g - b) / d) % 6; else if (mx === g) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h /= 6; if (h < 0) h += 1;
    }
    return [h, Math.min(1, s), l];
  }
  function hslHex(h, s, l) {
    var c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs(((h * 6) % 2) - 1)), m = l - c / 2, r = 0, g = 0, b = 0, i = Math.floor(h * 6) % 6;
    if (i === 0) { r = c; g = x; } else if (i === 1) { r = x; g = c; } else if (i === 2) { g = c; b = x; }
    else if (i === 3) { g = x; b = c; } else if (i === 4) { r = x; b = c; } else { r = c; b = x; }
    return '#' + [r, g, b].map(function (v) { return ('0' + Math.round((v + m) * 255).toString(16)).slice(-2); }).join('');
  }
  var sinirla = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  // Fotoğrafın (kırpılan bölümünün) renklerinden Spotify zemini: taban = koyu baskın renk, isik = parlak vurgu.
  // 24 ton kovası: koyu/orta pikseller tabanı, açık ve doygun pikseller parıltıyı belirler. Renksiz fotoğrafta sıcak gri.
  function renkCikar(kaynak, kirp) {
    var N = 48, c = document.createElement('canvas');
    c.width = N; c.height = N;
    var x = c.getContext('2d', { willReadFrequently: true });
    var sw = kaynak.width, sh = kaynak.height;
    x.drawImage(kaynak, kirp.x * sw, kirp.y * sh, kirp.w * sw, kirp.h * sh, 0, 0, N, N);
    var p = x.getImageData(0, 0, N, N).data, K = 24, kova = [], renkli = 0;
    for (var i = 0; i < K; i++) kova.push({ koyu: 0, parlak: 0, kr: 0, kg: 0, kb: 0, pr: 0, pg: 0, pb: 0 });
    for (var j = 0; j < p.length; j += 4) {
      var hsl = rgbHsl(p[j], p[j + 1], p[j + 2]);
      if (hsl[1] < 0.16 || hsl[2] < 0.08 || hsl[2] > 0.93) continue;
      renkli++;
      var o = kova[Math.floor(hsl[0] * K) % K];
      if (hsl[2] < 0.58) { var w = hsl[1]; o.koyu += w; o.kr += p[j] * w; o.kg += p[j + 1] * w; o.kb += p[j + 2] * w; }
      if (hsl[2] > 0.42) { var v = hsl[1] * hsl[2]; o.parlak += v; o.pr += p[j] * v; o.pg += p[j + 1] * v; o.pb += p[j + 2] * v; }
    }
    if (renkli / (N * N) < 0.08) {
      return { oto: { ad: 'Otomatik', taban: '#221F1C', isik: '#CFC6B8', derin: '#110F0E' }, diger: [] };
    }
    var komsu = function (alan) { return kova.map(function (o, i) { return o[alan] + 0.5 * (kova[(i + K - 1) % K][alan] + kova[(i + 1) % K][alan]); }); };
    var koyuP = komsu('koyu'), parlakP = komsu('parlak');
    var sirala = function (puan) { return puan.map(function (v, i) { return [v, i]; }).sort(function (a, b) { return b[0] - a[0]; }); };
    var koyuSira = sirala(koyuP), parlakSira = sirala(parlakP);
    var tonUzak = function (a, b) { var d = Math.abs(a - b); return Math.min(d, K - d); };
    var ortalama = function (o, onEk) { var t = onEk === 'k' ? o.koyu : o.parlak; return t > 0 ? rgbHsl(o[onEk + 'r'] / t, o[onEk + 'g'] / t, o[onEk + 'b'] / t) : null; };
    var tabanRenk = function (i) {
      var h = ortalama(kova[i], 'k') || ortalama(kova[i], 'p') || [i / K, 0.4, 0.3];
      return { taban: hslHex(h[0], sinirla(h[1], 0.28, 0.62), 0.14), derin: hslHex(h[0], sinirla(h[1], 0.25, 0.6), 0.07) };
    };
    var isikRenk = function (i) {
      var h = ortalama(kova[i], 'p') || ortalama(kova[i], 'k') || [i / K, 0.5, 0.6];
      return hslHex(h[0], sinirla(h[1] * 1.45, 0.5, 0.85), 0.69);
    };
    var ilkTaban = (koyuSira[0][0] > 0 ? koyuSira : parlakSira)[0][1];
    var ilkIsik = function (taban) {
      var enIyi = parlakSira[0];
      for (var i = 0; i < parlakSira.length; i++) {
        var a = parlakSira[i];
        if (tonUzak(a[1], taban) >= 2 && a[0] >= enIyi[0] * 0.3) return a[1];
      }
      return enIyi[0] > 0 ? enIyi[1] : taban;
    };
    var palet = function (ad, t, k) { var r = tabanRenk(t); return { ad: ad, taban: r.taban, derin: r.derin, isik: isikRenk(k) }; };
    var oto = palet('Otomatik', ilkTaban, ilkIsik(ilkTaban));
    var diger = [], gorulen = {};
    gorulen[oto.taban + oto.isik] = 1;
    var ekle = function (p) { if (!gorulen[p.taban + p.isik]) { gorulen[p.taban + p.isik] = 1; diger.push(p); } };
    var isikI = ilkIsik(ilkTaban);
    ekle(palet('Ters', isikI, ilkTaban)); // parlak rengin koyusu zemin, baskın renk parıltı
    for (var s = 1; s < koyuSira.length && diger.length < 3; s++) {
      if (koyuSira[s][0] < koyuSira[0][0] * 0.2) break;
      if (tonUzak(koyuSira[s][1], ilkTaban) >= 2) ekle(palet('Alternatif', koyuSira[s][1], ilkIsik(koyuSira[s][1])));
    }
    ekle(palet('Tek renk', ilkTaban, ilkTaban));
    return { oto: oto, diger: diger.slice(0, 3) };
  }

  /* ---------- Çizim yardımcıları ---------- */
  // Yazıyı genişliğe sığdırır: önce küçültür (en az asgari), yine sığmazsa sonunu "…" ile keser
  function sigdir(ctx, metin, agirlik, boy, asgari, aile, azami) {
    var b = boy;
    ctx.font = agirlik + ' ' + b + 'px ' + aile;
    while (ctx.measureText(metin).width > azami && b > asgari) { b -= Math.max(0.5, boy * 0.02); ctx.font = agirlik + ' ' + b + 'px ' + aile; }
    if (ctx.measureText(metin).width > azami) {
      var kes = Array.from(metin);
      while (kes.length && ctx.measureText(kes.join('') + '…').width > azami) kes.pop();
      metin = kes.join('').trim() + '…';
    }
    return metin;
  }
  // Dolu metin; boşsa önizlemede örnek metin soluk çizilir (baskıya örnek girmez)
  function yazi(ctx, d, metin, ornek, x, y, stil) {
    var t = String(metin || '').trim();
    if (!t) { if (d.mod !== 'onizleme' || !ornek) return; t = ornek; }
    ctx.save();
    if (!String(metin || '').trim()) ctx.globalAlpha *= 0.42;
    ctx.fillStyle = stil.renk;
    ctx.textAlign = stil.hiza || 'left';
    ctx.textBaseline = 'alphabetic';
    var y2 = sigdir(ctx, t, stil.agirlik, stil.boy, stil.boy * 0.55, stil.aile, stil.azami);
    ctx.fillText(y2, x, y);
    ctx.restore();
  }
  var sureYaz = function (ms) { var t = Math.round((ms || 0) / 1000); return Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0'); };
  function sureOku(v) {
    var m = String(v || '').trim().match(/^(\d{1,2})[:.](\d{2})$/);
    return m ? (+m[1] * 60 + +m[2]) * 1000 : 0;
  }

  // Müşterinin döndürmesi (90° adımlar, saat yönünde) uygulanmış görselin boyutu
  function etkinBoyut(f) { return f.don % 2 ? { w: f.ih, h: f.iw } : { w: f.iw, h: f.ih }; }

  // Fotoğrafın kutuya giren bölgesi (oran; EXIF yönü ve döndürme uygulanmış görselde). z ≥ 1 yakınlaştırma, cx/cy kırpma merkezi.
  function kirpHesapla(f, oran) {
    var b = etkinBoyut(f), cw = Math.min(b.w, b.h * oran) / f.z, ch = cw / oran;
    var x = sinirla(f.cx * b.w - cw / 2, 0, b.w - cw), y = sinirla(f.cy * b.h - ch / 2, 0, b.h - ch);
    return { x: x / b.w, y: y / b.h, w: cw / b.w, h: ch / b.h };
  }

  // Tuvali 90°·don saat yönünde döndürür
  function dondur(kaynak, don) {
    if (!don) return kaynak;
    var c = document.createElement('canvas');
    c.width = don % 2 ? kaynak.height : kaynak.width;
    c.height = don % 2 ? kaynak.width : kaynak.height;
    var x = c.getContext('2d');
    x.translate(c.width / 2, c.height / 2);
    x.rotate((don * Math.PI) / 2);
    x.drawImage(kaynak, -kaynak.width / 2, -kaynak.height / 2);
    return c;
  }
  // Önizlemede kullanılan görsel (siyah-beyazsa gri kopya), döndürme uygulanmış; önbellekli
  function etkinKaynak(f, gri) {
    var temel = gri && f.gri ? f.gri : f.onizleme, a = (temel === f.gri ? 'g' : 'r') + f.don;
    f.onbellek = f.onbellek || {};
    if (!f.onbellek[a]) f.onbellek[a] = dondur(temel, f.don);
    return f.onbellek[a];
  }

  // Fotoğraf ya da (önizlemede) yer tutucu. Zemin çizerken (baskı) kutu boş kalır: fotoğraf PDF'te üste orijinaliyle konur.
  function fotoKutusu(ctx, d, k, kutu, yerRenk) {
    var x = kutu.x * k, y = kutu.y * k, w = kutu.w * k, h = kutu.h * k;
    if (d.foto && d.mod !== 'zemin') {
      var kaynak = etkinKaynak(d.foto, d.gri);
      var r = kirpHesapla(d.foto, kutu.w / kutu.h), sw = kaynak.width, sh = kaynak.height;
      ctx.drawImage(kaynak, r.x * sw, r.y * sh, r.w * sw, r.h * sh, x, y, w, h);
      return;
    }
    if (d.mod !== 'onizleme') return;
    ctx.save();
    ctx.fillStyle = yerRenk.zemin;
    ctx.fillRect(x, y, w, h);
    ctx.setLineDash([14 * k, 10 * k]);
    ctx.strokeStyle = yerRenk.cizgi;
    ctx.lineWidth = 3 * k;
    ctx.strokeRect(x + 1.5 * k, y + 1.5 * k, w - 3 * k, h - 3 * k);
    ctx.setLineDash([]);
    ctx.fillStyle = yerRenk.yazi;
    ctx.font = '600 ' + (30 * k) + 'px system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(d.yerTutucu || '', x + w / 2, y + h / 2);
    ctx.restore();
  }

  // Spotify kodu (vektör). icerik: true → logo + çubukların kapladığı 360×60'lık alan (x 20–380, y 20–80) kutuya oturur;
  // false → SVG'nin tamamı (400×100, kenar boşluklarıyla).
  function kodCiz(ctx, d, k, kutu, renk, icerik) {
    if (!d.kod || !d.kodGoster) {
      if (d.mod !== 'onizleme' || d.kodGoster === false) return;
      ctx.save();
      ctx.setLineDash([10 * k, 8 * k]);
      ctx.strokeStyle = rgba(renk, 0.45);
      ctx.lineWidth = 2.5 * k;
      ctx.strokeRect(kutu.x * k, kutu.y * k, kutu.w * k, kutu.h * k);
      ctx.setLineDash([]);
      ctx.fillStyle = rgba(renk, 0.6);
      ctx.font = '600 ' + (Math.min(24, kutu.h * 0.4) * k) + 'px system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(d.kodYerTutucu || '', (kutu.x + kutu.w / 2) * k, (kutu.y + kutu.h / 2) * k);
      ctx.restore();
      return;
    }
    var o = icerik ? (kutu.w / 360) * k : (kutu.w / 400) * k, x0 = icerik ? 20 : 0, y0 = icerik ? 20 : 0;
    ctx.save();
    ctx.translate(kutu.x * k - x0 * o, kutu.y * k - y0 * o);
    ctx.scale(o, o);
    ctx.fillStyle = renk;
    d.kod.cubuklar.forEach(function (c) {
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(c.x, c.y, c.w, c.h, c.r); else ctx.rect(c.x, c.y, c.w, c.h);
      ctx.fill();
    });
    if (d.kod.logo) { ctx.translate(d.kod.logo.tx, d.kod.logo.ty); ctx.fill(new Path2D(d.kod.logo.d)); }
    ctx.restore();
  }

  /* ---------- Spotify posteri ---------- */
  var IKON = {
    karisik: new Path2D('M3 7h4l10 10h4M3 17h4l3-3M14 10l3-3h4M18 4l3 3-3 3M18 14l3 3-3 3'),
    tekrar: new Path2D('M8 18H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-5M15 15l-3 3 3 3'),
  };

  function spotifyCiz(cv, d) {
    var W = cv.width, H = cv.height, k = W / BW, ctx = cv.getContext('2d');
    var p = d.palet || HAZIR_PALET.yesil;
    // Zemin: taban + sol üstten (55° aşağı) parlak renk + altta koyulaşma (PSD'deki üç dolgu katmanı)
    ctx.fillStyle = p.taban;
    ctx.fillRect(0, 0, W, H);
    var g = ctx.createLinearGradient(0, 0, 645 * k, 922 * k);
    [[0, 1], [0.255, 0.58], [0.51, 0.28], [0.78, 0.08], [1, 0]].forEach(function (s) { g.addColorStop(s[0], rgba(p.isik, s[1])); });
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
    var g2 = ctx.createLinearGradient(0, 0.55 * H, 0, H);
    g2.addColorStop(0, rgba(p.derin, 0));
    g2.addColorStop(1, rgba(p.derin, 0.55));
    ctx.fillStyle = g2;
    ctx.fillRect(0, 0.55 * H, W, 0.45 * H);

    // Üst satır: aşağı ok, isimler, üç nokta
    ctx.save();
    ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = 4.2 * k; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath(); ctx.moveTo(163 * k, 100 * k); ctx.lineTo(180 * k, 116 * k); ctx.lineTo(197 * k, 100 * k); ctx.stroke();
    ctx.fillStyle = '#FFFFFF';
    [809.3, 822.4, 835.3].forEach(function (cx) { ctx.beginPath(); ctx.arc(cx * k, 108.4 * k, 3.47 * k, 0, Math.PI * 2); ctx.fill(); });
    ctx.restore();
    yazi(ctx, d, d.isimler, d.ornek.isimler, 500 * k, 118 * k, { renk: '#FFFFFF', hiza: 'center', agirlik: '400', boy: 24.7 * k, aile: '"Arimo", Arial, sans-serif', azami: 560 * k });

    // Kapak fotoğrafı (kare)
    fotoKutusu(ctx, d, k, KUTU.spotify, { zemin: 'rgba(255,255,255,0.08)', cizgi: 'rgba(255,255,255,0.45)', yazi: 'rgba(255,255,255,0.8)' });

    // Şarkı adı, sanatçı, beğeni işareti
    yazi(ctx, d, d.sarki, d.ornek.sarki, 160.9 * k, 920.9 * k, { renk: '#FFFFFF', agirlik: '400', boy: 40 * k, aile: '"Arimo", Arial, sans-serif', azami: 600 * k });
    yazi(ctx, d, d.sanatci, d.ornek.sanatci, 160.9 * k, 961.4 * k, { renk: '#FFFFFF', agirlik: '400', boy: 27.7 * k, aile: '"Arimo", Arial, sans-serif', azami: 600 * k });
    ctx.save();
    ctx.fillStyle = YESIL;
    ctx.beginPath(); ctx.arc(811.7 * k, 910.6 * k, 28.9 * k, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = 5.2 * k; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath(); ctx.moveTo(800.2 * k, 911.5 * k); ctx.lineTo(808.3 * k, 919.5 * k); ctx.lineTo(824.3 * k, 902.8 * k); ctx.stroke();
    ctx.restore();

    // Süre çubuğu ve süreler (çubuk şarkının ~%37'sinde)
    var sol = 160.7, sag = 838.8, cy = 1005.25, bx = sol + (sag - sol) * ILERLEME;
    ctx.save();
    ctx.lineCap = 'round';
    ctx.lineWidth = 8.5 * k;
    ctx.strokeStyle = 'rgba(255,255,255,0.33)';
    ctx.beginPath(); ctx.moveTo((sol + 4.25) * k, cy * k); ctx.lineTo((sag - 4.25) * k, cy * k); ctx.stroke();
    ctx.strokeStyle = '#FFFFFF';
    ctx.beginPath(); ctx.moveTo((sol + 4.25) * k, cy * k); ctx.lineTo(bx * k, cy * k); ctx.stroke();
    ctx.fillStyle = '#FFFFFF';
    ctx.beginPath(); ctx.arc(bx * k, cy * k, 13.4 * k, 0, Math.PI * 2); ctx.fill();
    ctx.restore();
    var sure = d.sureMs || (d.mod === 'onizleme' ? 199000 : 0);
    if (sure) {
      ctx.save();
      if (!d.sureMs) ctx.globalAlpha = 0.42;
      ctx.fillStyle = '#FFFFFF';
      ctx.font = '400 ' + (22.45 * k) + 'px "Arimo", Arial, sans-serif';
      ctx.textBaseline = 'alphabetic';
      ctx.textAlign = 'left';
      ctx.fillText(sureYaz(sure * ILERLEME), 160.9 * k, 1042.7 * k);
      ctx.textAlign = 'right';
      ctx.fillText(sureYaz(sure), 839 * k, 1042.7 * k);
      ctx.restore();
    }

    // Çalar düğmeleri: karıştır (yeşil), önceki, duraklat, sonraki, tekrar (yeşil)
    var ikon = function (yol, x0, y0, en) {
      var s = (en * k) / 24;
      ctx.save();
      ctx.translate(x0 * k, y0 * k);
      ctx.scale(s, s);
      ctx.strokeStyle = YESIL; ctx.lineWidth = 2.1; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.stroke(yol);
      ctx.restore();
    };
    ikon(IKON.karisik, 160.5, 1098.5, 47.3);
    ikon(IKON.tekrar, 795.5, 1095, 45);
    ctx.save();
    ctx.fillStyle = YESIL;
    [179.7, 814.7].forEach(function (cx) { ctx.beginPath(); ctx.arc(cx * k, 1150.5 * k, 4.2 * k, 0, Math.PI * 2); ctx.fill(); });
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(311.1 * k, 1103 * k, 10.1 * k, 47 * k);
    ctx.beginPath(); ctx.moveTo(353.7 * k, 1103 * k); ctx.lineTo(353.7 * k, 1149.3 * k); ctx.lineTo(314 * k, 1126.2 * k); ctx.closePath(); ctx.fill();
    ctx.fillRect(678.8 * k, 1103 * k, 10.1 * k, 47 * k);
    ctx.beginPath(); ctx.moveTo(646.4 * k, 1103 * k); ctx.lineTo(646.4 * k, 1149.3 * k); ctx.lineTo(686.1 * k, 1126.2 * k); ctx.closePath(); ctx.fill();
    ctx.beginPath(); ctx.arc(500.1 * k, 1124.3 * k, 65.1 * k, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = p.derin;
    ctx.fillRect(482 * k, 1102 * k, 12.5 * k, 44.5 * k);
    ctx.fillRect(506 * k, 1102 * k, 12.5 * k, 44.5 * k);
    ctx.restore();

    // Spotify kodu (beyaz)
    kodCiz(ctx, d, k, { x: 355, y: 1231.4, w: 289.9, h: 48.4 }, '#FFFFFF', true);
  }

  /* ---------- Forever posteri ---------- */
  function foreverCiz(cv, d) {
    var W = cv.width, H = cv.height, k = W / BW, ctx = cv.getContext('2d');
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, W, H);
    // Siyah kemer (PSD'de üstten taşan büyük elips)
    ctx.fillStyle = '#000000';
    ctx.beginPath(); ctx.ellipse(500 * k, 156 * k, 631.1 * k, 504.4 * k, 0, 0, Math.PI * 2); ctx.fill();

    // Başlık: sabit "Forever" (vektör), PSD'deki kutusuna
    if (!foreverYolu) foreverYolu = new Path2D(FOREVER_YOL);
    var bo = (FOREVER_KUTU[2] / FOREVER_SINIR[2]) * k;
    ctx.save();
    ctx.translate(FOREVER_KUTU[0] * k - FOREVER_SINIR[0] * bo, FOREVER_KUTU[1] * k - FOREVER_SINIR[1] * bo);
    ctx.scale(bo, bo);
    ctx.fillStyle = '#FFFFFF';
    ctx.fill(foreverYolu);
    ctx.restore();

    // Tarih şeridi: iki ince çizgi arasında tarih (sol) ve yıl (sağ)
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(93 * k, 230.1 * k, 814 * k, 2.03 * k);
    ctx.fillRect(93 * k, 268 * k, 814 * k, 2.03 * k);
    var ince = { renk: '#FFFFFF', agirlik: '300', boy: 24.6 * k, aile: '"Montserrat", sans-serif', azami: 560 * k };
    yazi(ctx, d, d.tarih, d.ornek.tarih, 112.5 * k, 258.8 * k, ince);
    yazi(ctx, d, d.yil, d.ornek.yil, 887.5 * k, 258.8 * k, Object.assign({}, ince, { hiza: 'right', azami: 200 * k }));

    fotoKutusu(ctx, d, k, KUTU.forever, { zemin: '#E9E9E9', cizgi: '#9A9A9A', yazi: '#555555' });

    // Şarkı, sanatçı, sözler
    yazi(ctx, d, d.sarki, d.ornek.sarki, 111.5 * k, 973.3 * k, { renk: '#000000', agirlik: '300', boy: 43.2 * k, aile: '"Montserrat", sans-serif', azami: 795 * k });
    yazi(ctx, d, d.sanatci, d.ornek.sanatci, 111.8 * k, 1011.4 * k, { renk: '#000000', agirlik: '700', boy: 24.6 * k, aile: '"Montserrat", sans-serif', azami: 795 * k });
    var satirlar = String(d.sozler || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 5);
    var ornekMi = !satirlar.length;
    if (ornekMi && d.mod === 'onizleme') satirlar = d.ornek.sozler;
    satirlar.forEach(function (s, i) {
      yazi(ctx, d, ornekMi ? '' : s, s, 111.3 * k, (1065 + i * 29.9) * k, { renk: '#000000', agirlik: '300', boy: 24.6 * k, aile: '"Montserrat", sans-serif', azami: 795 * k });
    });

    // Spotify kodu (siyah, kenar boşluklarıyla) ve alt çizgi
    kodCiz(ctx, d, k, { x: 311.2, y: 1213.9, w: 377.7, h: 94.5 }, '#000000', false);
    ctx.fillStyle = '#0B0B0B';
    ctx.fillRect(93 * k, 1317.8 * k, 814 * k, 2 * k);
  }

  var CIZICILER = { spotify: spotifyCiz, forever: foreverCiz };
  function posterCiz(cv, d) { (CIZICILER[d.tasarim] || spotifyCiz)(cv, d); }

  // Spotify kodu SVG'si → çubuklar + logo yolu (vektör çizim için)
  async function kodAl(url) {
    var r = await fetch(url);
    if (!r.ok) throw new Error('kod alınamadı');
    var doc = new DOMParser().parseFromString(await r.text(), 'image/svg+xml');
    var cubuklar = Array.prototype.map.call(doc.querySelectorAll('rect'), function (e) {
      return { x: +e.getAttribute('x') || 0, y: +e.getAttribute('y') || 0, w: +e.getAttribute('width') || 0, h: +e.getAttribute('height') || 0, r: +(e.getAttribute('rx') || 0) };
    }).filter(function (c) { return c.w > 0 && c.w < 200; });
    var p = doc.querySelector('path'), logo = null;
    if (p) {
      var t = ((p.parentNode && p.parentNode.getAttribute && p.parentNode.getAttribute('transform')) || '').match(/translate\(\s*([\d.-]+)[\s,]+([\d.-]+)/);
      logo = { d: p.getAttribute('d'), tx: t ? +t[1] : 0, ty: t ? +t[2] : 0 };
    }
    if (!cubuklar.length) throw new Error('kod boş');
    return { cubuklar: cubuklar, logo: logo };
  }

  /* ---------- Fotoğraf ---------- */
  function resimAc(dosya) {
    return new Promise(function (tamam, red) {
      var url = URL.createObjectURL(dosya), img = new Image();
      img.onload = function () { tamam({ img: img, url: url }); };
      img.onerror = function () { URL.revokeObjectURL(url); red(new Error('açılamadı')); };
      img.src = url;
    });
  }
  // Ön izleme kopyası: en uzun kenar 1600 px (tarayıcı EXIF yönünü uygular)
  function kucukKopya(img, azami) {
    var w = img.naturalWidth, h = img.naturalHeight, o = Math.min(1, azami / Math.max(w, h));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * o)); c.height = Math.max(1, Math.round(h * o));
    var x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.drawImage(img, 0, 0, c.width, c.height);
    return c;
  }
  function griYap(kaynak) {
    var c = document.createElement('canvas');
    c.width = kaynak.width; c.height = kaynak.height;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(kaynak, 0, 0);
    var v = x.getImageData(0, 0, c.width, c.height), p = v.data;
    for (var i = 0; i < p.length; i += 4) { var l = 0.299 * p[i] + 0.587 * p[i + 1] + 0.114 * p[i + 2]; p[i] = p[i + 1] = p[i + 2] = l; }
    x.putImageData(v, 0, 0);
    return c;
  }
  // JPEG başlığından bileşen sayısı (4 = CMYK); JPEG değilse 0
  async function jpegBilesen(dosya) {
    var u = new Uint8Array(await dosya.slice(0, 512 * 1024).arrayBuffer());
    if (u[0] !== 0xff || u[1] !== 0xd8) return 0;
    var p = 2;
    while (p + 9 < u.length) {
      if (u[p] !== 0xff) { p++; continue; }
      var m = u[p + 1];
      if (m === 0xd8 || m === 0x01 || (m >= 0xd0 && m <= 0xd7)) { p += 2; continue; }
      if (m >= 0xc0 && m <= 0xcf && m !== 0xc4 && m !== 0xc8 && m !== 0xcc) return u[p + 9];
      p += 2 + ((u[p + 2] << 8) | u[p + 3]);
    }
    return 3;
  }
  // Baskıya giden fotoğraf: JPEG ise dosyanın kendisi (kayıpsız). Siyah-beyaz, CMYK ya da başka biçimse tarayıcıda
  // tam çözünürlükte (en çok 16 MP; iOS tuval sınırı) JPEG %95 olarak yeniden kodlanır.
  async function baskiFotosu(dosya, gri) {
    var bilesen = await jpegBilesen(dosya);
    if (bilesen && bilesen !== 4 && !gri) return dosya;
    var a = await resimAc(dosya);
    try {
      var w = a.img.naturalWidth, h = a.img.naturalHeight, o = Math.min(1, Math.sqrt(16e6 / (w * h)));
      var c = document.createElement('canvas');
      c.width = Math.round(w * o); c.height = Math.round(h * o);
      var x = c.getContext('2d');
      x.fillStyle = '#FFFFFF';
      x.fillRect(0, 0, c.width, c.height);
      if (gri && 'filter' in x) x.filter = 'grayscale(1)';
      x.drawImage(a.img, 0, 0, c.width, c.height);
      var son = gri && !('filter' in x) ? griYap(c) : c;
      return await new Promise(function (tamam, red) { son.toBlob(function (b) { if (b) tamam(b); else red(new Error('kodlanamadı')); }, 'image/jpeg', 0.95); });
    } finally {
      URL.revokeObjectURL(a.url);
    }
  }

  /* ---------- Stüdyo ---------- */
  var SIMGE = {
    yukle: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="9" r="1.8"/><path d="M21 15l-5-5L5 21"/></svg>',
    yukari: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>',
    ara: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
    sil: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    tik: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  };
  var METIN = {
    foto: 'Fotoğraf Yükle',
    fotoAlt: 'Baskıda fotoğrafın orijinal kalitesinde kullanılır',
    degistir: 'Değiştir',
    fotoBaslik: 'Fotoğrafınız:',
    farkli: 'Farklı Bir Resim Yükle',
    duzenle: 'Fotoğrafı Düzenle',
    kaldir: 'Fotoğrafı kaldır',
    duzenleBaslik: 'Fotoğrafını yerleştir',
    uzaklas: 'Uzaklaştır',
    solaDondur: 'Sola döndür',
    sagaDondur: 'Sağa döndür',
    sola: 'Sola kaydır',
    saga: 'Sağa kaydır',
    yukariTasi: 'Yukarı kaydır',
    asagiTasi: 'Aşağı kaydır',
    iptal: 'İptal',
    kaydet: 'Kaydet',
    konum: 'Sürükleyerek konumlandır',
    yakinlas: 'Yakınlaştır',
    dusukKalite: 'Fotoğrafın çözünürlüğü düşük; büyük boyutlarda (50×70) bulanık görünebilir.',
    yerTutucu: 'Fotoğrafın burada olacak',
    renk: 'Arka plan rengi',
    renkOto: 'Fotoğrafa göre',
    fotoRenk: 'Fotoğraf',
    siyahBeyaz: 'Siyah-beyaz',
    renkli: 'Renkli',
    isimler: 'İsimler',
    isimlerOrnek: 'Zeynep & Halil',
    spotify: 'Şarkını bul',
    spotifyOrnek: 'Şarkı ya da sanatçı ara…',
    spotifyYardim: 'Şarkının adını ya da sanatçıyı yaz, listeden seç; Spotify linki yapıştırmak da olur. Şarkı adı, sanatçı ve süre kendiliğinden dolar.',
    spotifyYardimForever: 'Şarkının adını ya da sanatçıyı yaz, listeden seç; Spotify linki yapıştırmak da olur. Şarkı adı, sanatçı ve sözler kendiliğinden dolar.',
    araYok: 'Bu aramayla şarkı bulunamadı. Farklı yazmayı dene ya da Spotify linkini yapıştır.',
    araHata: 'Arama şu an yapılamadı, biraz sonra tekrar dene ya da Spotify linkini yapıştır.',
    araSil: 'Aramayı temizle',
    seciliDegistir: 'Değiştir',
    spotifyAraniyor: 'Şarkı aranıyor…',
    spotifyBulundu: 'Bulundu:',
    spotifyHata: 'Bu linkte bir Spotify şarkısı bulunamadı.',
    sarki: 'Şarkı adı',
    sarkiOrnek: 'In The Dark',
    sarkiOrnekForever: 'Vazgeçilmezim',
    sanatci: 'Sanatçı',
    sanatciOrnek: 'Jend',
    sanatciOrnekForever: 'Sinan Akçıl, Demet Akalın',
    sure: 'Süre',
    sureOrnek: '3:19',
    kod: 'Spotify kodu eklensin',
    kodYerTutucu: 'Spotify kodu burada olacak',
    kodYok: 'Spotify kodu için şarkı linkini yapıştır.',
    tarih: 'Tarih',
    tarihOrnek: '08 Temmuz',
    yil: 'Yıl',
    yilOrnek: '2024',
    sozler: 'Şarkı sözleri (en çok 5 satır)',
    sozlerOrnek: 'Sözleri yazın ya da aşağıdan seçin',
    sozSec: 'Şarkı sözlerinden seç (en çok 4 satır)',
    sozAraniyor: 'Şarkı sözleri aranıyor…',
    sozYok: 'Bu şarkının sözleri bulunamadı; sözleri kendin yazabilirsin.',
    polaroid: 'Hediye polaroid fotoğrafı (isteğe bağlı)',
    polaroidAlt: 'Tablonla birlikte kutuda küçük bir polaroid baskısı gelir.',
    polaroidSec: 'Polaroid fotoğrafı seç',
    polaroidKaldir: 'Kaldır',
    yukari: 'Posterin yukarıda, görmek için dokun',
    gorunum: 'Görünüm',
    gorunumPoster: 'Posterin',
    gorunumGaleri: 'Ürün fotoğrafları',
    once: 'Önce fotoğrafını yükle.',
    sarkiOnce: 'Önce şarkını ara ve listeden seç (ya da şarkı adını kendin yaz).',
    acilamadi: 'Bu fotoğraf açılamadı. JPG veya PNG bir fotoğraf dene.',
    baskiHazirlaniyor: 'Baskı dosyan hazırlanıyor…',
    yukleniyor: 'Fotoğrafın yükleniyor',
    baskiHata: 'Baskı dosyası gönderilemedi, lütfen tekrar dene.',
    kvkk: 'Fotoğrafın yalnızca tablonun basımı için kullanılır.',
    kvkkLink: 'Aydınlatma Metni',
  };
  var ORNEK_SOZ = ['Sen bir meleksin, her şey demeksin', 'Tut hep elimi vazgeçilmezim', 'Sen bir meleksin, her şey demeksin', 'Kalpte sevgisi söndürülmezim'];
  var TASARIM = { spotify: { ad: 'Spotify Poster' }, forever: { ad: 'Forever Poster' } };
  var RENKLER = [[/beyaz|white/i, 'beyaz'], [/siyah|black/i, 'siyah'], [/ceviz|walnut/i, 'ceviz'], [/ah[sş]ap|naturel|wood|me[sş]e/i, 'ahsap'], [/alt[ıi]n|gold/i, 'altin']];
  function el(etiket, sinif, html) { var e = document.createElement(etiket); if (sinif) e.className = sinif; if (html != null) e.innerHTML = html; return e; }
  function kimlik() { return Math.random().toString(36).slice(2, 8); }

  function Studyo(kok) {
    var ayarEl = kok.querySelector('[data-fso-muzik-ayar]');
    var ayar = {};
    try { ayar = JSON.parse(ayarEl ? ayarEl.textContent : '{}'); } catch (e) { console.warn('[muzik] ayar okunamadı', e); }
    this.kok = kok;
    this.ayar = ayar;
    this.api = String(ayar.api || '').replace(/\/+$/, '');
    this.m = Object.assign({}, METIN, ayar.metinler || {});
    this.form = ayar.form ? document.querySelector(ayar.form) : kok.closest('form');
    this.medya = ayar.medya ? document.querySelector(ayar.medya) : null;
    this.tasarim = TASARIM[ayar.tasarim] ? ayar.tasarim : 'spotify';
    this.foto = null;
    this.paletler = null;
    this.paletSec = 'oto';
    this.sarkiBilgi = null;
    this.polaroid = null;
    this.kur();
  }

  Studyo.prototype.kur = function () {
    var s = this, m = this.m, f = this.tasarim === 'forever', id = kimlik();
    var alan = function (anahtar, ic) { return '<label class="fso-mp-alan"><span data-mp-et="' + anahtar + '"></span>' + ic + '</label>'; };
    var kart = el('div', 'fso-mp');
    kart.setAttribute('data-tasarim', this.tasarim);
    kart.innerHTML =
      '<div class="fso-mp-foto" data-mp-foto>' +
        '<p class="fso-mp-foto-baslik"><span data-mp-et="fotoBaslik"></span> <span class="fso-mp-zorunlu" aria-hidden="true">*</span></p>' +
        '<label class="fso-mp-yukle" data-mp-yukle><input type="file" accept="image/*" class="fso-mp-dosya" data-mp-dosya>' +
          '<span class="fso-mp-ikon">' + SIMGE.yukle + '</span><span class="fso-mp-yukle-yazi"><strong data-mp-et="foto"></strong><small data-mp-et="fotoAlt"></small></span></label>' +
        '<div class="fso-mp-yuklu" data-mp-yuklu hidden>' +
          '<div class="fso-mp-kucuk"><canvas class="fso-mp-kucuk-tuval" data-mp-kucuk width="300" height="400" role="img" aria-label="Yüklediğin fotoğraf"></canvas>' +
            '<button type="button" class="fso-mp-kucuk-sil" data-mp-sil><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
          '<div class="fso-mp-yuklu-eylem">' +
            '<label class="fso-mp-farkli"><input type="file" accept="image/*" class="fso-mp-dosya" data-mp-dosya><span data-mp-et="farkli"></span></label>' +
            '<button type="button" class="fso-mp-duzenle" data-mp-duzenle data-mp-et="duzenle"></button>' +
          '</div>' +
          '<p class="fso-mp-uyari" data-mp-uyari hidden></p>' +
        '</div>' +
      '</div>' +
      (f
        ? '<div class="fso-mp-secim" role="radiogroup" data-mp-fotorenk><span class="fso-mp-secim-baslik" data-mp-et="fotoRenk"></span>' +
            '<label><input type="radio" name="mp-fr-' + id + '" value="sb" checked><span data-mp-et="siyahBeyaz"></span></label>' +
            '<label><input type="radio" name="mp-fr-' + id + '" value="renkli"><span data-mp-et="renkli"></span></label></div>' +
          '<div class="fso-mp-ikili">' + alan('tarih', '<input type="text" maxlength="24" autocomplete="off" data-mp-tarih>') + alan('yil', '<input type="text" inputmode="numeric" maxlength="4" autocomplete="off" data-mp-yil>') + '</div>'
        : '<div class="fso-mp-paletler" data-mp-paletler hidden><span class="fso-mp-secim-baslik" data-mp-et="renk"></span><div class="fso-mp-renkler" role="radiogroup" data-mp-renkler></div></div>' +
          alan('isimler', '<input type="text" maxlength="32" autocomplete="off" data-mp-isimler>')) +
      '<div class="fso-mp-alan fso-mp-ara-alan" data-mp-ara-alan><label for="mp-ara-' + id + '" data-mp-et="spotify"></label>' +
        '<div class="fso-mp-ara">' + SIMGE.ara +
          '<input id="mp-ara-' + id + '" type="search" enterkeyhint="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="mp-sonuc-' + id + '" data-mp-spotify>' +
          '<span class="fso-mp-ara-donen" data-mp-ara-donen hidden></span>' +
          '<button type="button" class="fso-mp-ara-sil" data-mp-ara-sil hidden>' + SIMGE.sil + '</button>' +
        '</div>' +
        '<ul class="fso-mp-sonuclar" id="mp-sonuc-' + id + '" role="listbox" data-mp-sonuclar hidden></ul>' +
      '</div>' +
      '<div class="fso-mp-secili" data-mp-secili hidden><img alt="" data-mp-secili-kapak>' +
        '<span class="fso-mp-secili-yazi"><span class="fso-mp-secili-ad" data-mp-secili-ad></span><span class="fso-mp-secili-alt" data-mp-secili-alt></span></span>' +
        '<button type="button" class="fso-mp-secili-degistir" data-mp-secili-degistir data-mp-et="seciliDegistir"></button></div>' +
      '<p class="fso-mp-yardim" data-mp-spotify-durum aria-live="polite"></p>' +
      '<div class="fso-mp-ikili' + (f ? '' : ' fso-mp-ikili--sure') + '">' +
        alan('sarki', '<input type="text" maxlength="60" autocomplete="off" data-mp-sarki>') +
        alan('sanatci', '<input type="text" maxlength="60" autocomplete="off" data-mp-sanatci>') +
        (f ? '' : alan('sure', '<input type="text" inputmode="numeric" maxlength="5" autocomplete="off" data-mp-sure>')) +
      '</div>' +
      (f
        ? alan('sozler', '<textarea rows="4" maxlength="400" data-mp-sozler></textarea>') +
          '<div class="fso-mp-soz" data-mp-soz hidden><p class="fso-mp-secim-baslik" data-mp-et="sozSec"></p><div class="fso-mp-soz-liste" data-mp-soz-liste></div></div>' +
          '<p class="fso-mp-yardim" data-mp-soz-durum aria-live="polite" hidden></p>'
        : '') +
      '<label class="fso-mp-onay"><input type="checkbox" data-mp-kod checked disabled><span data-mp-et="kod"></span></label>' +
      (this.ayar.polaroid === false ? '' :
        '<div class="fso-mp-polaroid"><p class="fso-mp-secim-baslik" data-mp-et="polaroid"></p><p class="fso-mp-not" data-mp-et="polaroidAlt"></p>' +
          '<div class="fso-mp-polaroid-satir"><label class="fso-mp-pol-sec"><input type="file" accept="image/*" class="fso-mp-dosya" data-mp-polaroid><span data-mp-polaroid-ad></span></label>' +
          '<button type="button" class="fso-mp-pol-kaldir" data-mp-polaroid-kaldir hidden></button></div></div>') +
      '<div class="fso-mp-slot" data-mp-slot></div>' +
      '<button type="button" class="fso-mp-yukari" data-mp-yukari hidden>' + SIMGE.yukari + '<span data-mp-et="yukari"></span></button>' +
      '<p class="fso-mp-mesaj" data-mp-mesaj role="status" aria-live="polite"></p>' +
      '<p class="fso-mp-not"><span data-mp-et="kvkk"></span>' + (this.ayar.kvkk ? ' <a target="_blank" rel="noopener" data-mp-kvkk></a>' : '') + '</p>';
    this.kok.appendChild(kart);
    this.kart = kart;
    this.$ = function (q) { return kart.querySelector(q); };
    this.$$ = function (q) { return kart.querySelectorAll(q); };

    this.$$('[data-mp-et]').forEach(function (e) { e.textContent = m[e.getAttribute('data-mp-et')] || ''; });
    var yer = function (q, v) { var e = s.$(q); if (e) e.placeholder = v; };
    yer('[data-mp-isimler]', m.isimlerOrnek);
    yer('[data-mp-spotify]', m.spotifyOrnek);
    yer('[data-mp-sarki]', f ? m.sarkiOrnekForever : m.sarkiOrnek);
    yer('[data-mp-sanatci]', f ? m.sanatciOrnekForever : m.sanatciOrnek);
    yer('[data-mp-sure]', m.sureOrnek);
    yer('[data-mp-tarih]', m.tarihOrnek);
    yer('[data-mp-yil]', m.yilOrnek);
    yer('[data-mp-sozler]', m.sozlerOrnek);
    this.$('[data-mp-spotify-durum]').textContent = f ? m.spotifyYardimForever : m.spotifyYardim;
    var polAd = this.$('[data-mp-polaroid-ad]');
    if (polAd) polAd.textContent = m.polaroidSec;
    var polKaldir = this.$('[data-mp-polaroid-kaldir]');
    if (polKaldir) polKaldir.textContent = m.polaroidKaldir;
    var kvkkA = this.$('[data-mp-kvkk]');
    if (kvkkA) { kvkkA.href = this.ayar.kvkk; kvkkA.textContent = m.kvkkLink; }
    this.ornek = f
      ? { sarki: m.sarkiOrnekForever, sanatci: m.sanatciOrnekForever, tarih: m.tarihOrnek, yil: m.yilOrnek, sozler: ORNEK_SOZ }
      : { isimler: m.isimlerOrnek, sarki: m.sarkiOrnek, sanatci: m.sanatciOrnek };

    // Sahne: çerçeveli poster önizlemesi (ürün görsellerinin yerinde)
    var sahne = el('div', 'fso-mp-sahne');
    sahne.innerHTML = '<div class="fso-mp-duvar"><div class="fso-mp-cerceve" data-mp-cerceve><canvas class="fso-mp-tuval" data-mp-tuval width="720" height="1008" role="img" aria-label="Poster önizlemesi"></canvas></div></div>';
    this.sahne = sahne;
    this.tuval = sahne.querySelector('[data-mp-tuval]');
    var gorunumKutu = el('div', 'fso-mp-gorunum');
    gorunumKutu.setAttribute('role', 'group');
    gorunumKutu.setAttribute('aria-label', m.gorunum);
    gorunumKutu.innerHTML = '<button type="button" data-mp-gorunum="poster" aria-pressed="true"></button><button type="button" data-mp-gorunum="galeri" aria-pressed="false"></button>';
    gorunumKutu.querySelector('[data-mp-gorunum="poster"]').textContent = m.gorunumPoster;
    gorunumKutu.querySelector('[data-mp-gorunum="galeri"]').textContent = m.gorunumGaleri;
    gorunumKutu.querySelectorAll('[data-mp-gorunum]').forEach(function (b) { b.addEventListener('click', function () { s.gorunumSec(b.getAttribute('data-mp-gorunum')); }); });
    this.gorunumKutu = gorunumKutu;
    this.gorunum = 'poster';
    this.yerlestir();
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1025px)');
      (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () { s.yerlestir(); });
    }

    // Olaylar
    this.$$('[data-mp-dosya]').forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.files && inp.files[0]) s.fotoSec(inp.files[0]); inp.value = ''; });
    });
    var ciz = function () { s.ciz(); };
    ['[data-mp-isimler]', '[data-mp-sarki]', '[data-mp-sanatci]', '[data-mp-tarih]', '[data-mp-yil]'].forEach(function (q) { var e = s.$(q); if (e) e.addEventListener('input', ciz); });
    var sureGirdi = this.$('[data-mp-sure]');
    if (sureGirdi) sureGirdi.addEventListener('input', ciz);
    var sozGirdi = this.$('[data-mp-sozler]');
    if (sozGirdi) sozGirdi.addEventListener('input', function () { s.sozOto = false; s.ciz(); });
    this.$$('[data-mp-fotorenk] input').forEach(function (r) { r.addEventListener('change', function () { s.griHazirla(); s.kucukCiz(); s.ciz(); }); });
    this.$('[data-mp-kod]').addEventListener('change', ciz);
    this.aramaKur();
    this.$('[data-mp-sil]').addEventListener('click', function () { s.fotoKaldir(); });
    this.$('[data-mp-duzenle]').addEventListener('click', function () { s.duzenleAc(); });
    this.$('[data-mp-sil]').setAttribute('aria-label', m.kaldir);
    this.duzenleyiciKur();
    var pol = this.$('[data-mp-polaroid]');
    if (pol) {
      pol.addEventListener('change', function () { if (pol.files && pol.files[0]) s.polaroidSec(pol.files[0]); pol.value = ''; });
      this.$('[data-mp-polaroid-kaldir]').addEventListener('click', function () { s.polaroidSec(null); });
    }
    this.$('[data-mp-yukari]').addEventListener('click', function () { s.gorunumSec('poster'); s.sahne.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    ['pointerdown', 'focusin'].forEach(function (t) { kart.addEventListener(t, function () { yaziTipleriniYukle(); }, { once: true, passive: true }); });

    // Çerçeve rengi (ürünün "Çerçeve Rengi" seçimi önizlemedeki çerçeveyi değiştirir)
    this.renkGuncelle();
    document.addEventListener('click', function (e) {
      if (s.ayar.renk && e.target.closest && e.target.closest(s.ayar.renk.replace(/\.selected\b/, ''))) requestAnimationFrame(function () { s.renkGuncelle(); });
    });

    // Sipariş özellikleri + sepete ekleme kapısı
    if (this.form) {
      this.girdiler = {};
      var adlar = ['_tasarim', '_tasarim_pdf', '_tasarim_onizleme', '_foto', '_polaroid', '_sarki', '_sanatci', '_spotify'];
      adlar = adlar.concat(f ? ['_tarih', '_yil', '_sozler', '_foto_rengi'] : ['_isimler', '_sure', '_zemin_rengi']);
      adlar.forEach(function (ad) {
        var g = s.form.querySelector('input[name="properties[' + ad + ']"]');
        if (!g) { g = document.createElement('input'); g.type = 'hidden'; g.name = 'properties[' + ad + ']'; s.form.appendChild(g); }
        g.value = '';
        s.girdiler[ad] = g;
      });
      window.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
        if (b && b.form === s.form) s.gonderiliyor(e, b);
      }, true);
      window.addEventListener('submit', function (e) { if (e.target === s.form && !s.gecis) s.gonderiliyor(e, null); }, true);
    }

    yaziTipleriniYukle().then(function () { s.ciz(); });
    this.ciz();
  };

  // Önizleme ürün görsellerinin yerinde durur (galeri gizlenir); medya alanı yoksa kartın içine düşer
  Studyo.prototype.yerlestir = function () {
    var medyada = !!this.medya;
    if (medyada) {
      if (this.medya.firstElementChild !== this.gorunumKutu) this.medya.insertBefore(this.gorunumKutu, this.medya.firstChild);
      if (this.gorunumKutu.nextElementSibling !== this.sahne) this.gorunumKutu.after(this.sahne);
    } else if (this.sahne.parentNode !== this.$('[data-mp-slot]')) {
      this.$('[data-mp-slot]').appendChild(this.sahne);
    }
    this.galeri = this.ayar.galeri ? document.querySelector(this.ayar.galeri) : null;
    this.gorunumKutu.hidden = !(medyada && this.galeri);
    this.$('[data-mp-yukari]').hidden = !medyada;
    this.gorunumSec(medyada ? this.gorunum : 'poster');
  };

  Studyo.prototype.gorunumSec = function (gorunum) {
    var medyada = !!this.medya && this.sahne.parentNode === this.medya;
    this.gorunum = medyada && this.galeri && gorunum === 'galeri' ? 'galeri' : 'poster';
    var galeride = this.gorunum === 'galeri';
    if (this.galeri) this.galeri.classList.toggle('fso-mp-gizle', medyada && !galeride);
    this.sahne.hidden = galeride;
    this.gorunumKutu.querySelectorAll('[data-mp-gorunum]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-mp-gorunum') === (galeride ? 'galeri' : 'poster')));
    });
  };

  Studyo.prototype.renkGuncelle = function () {
    var secili = this.ayar.renk ? document.querySelector(this.ayar.renk) : null;
    var deger = secili ? (secili.getAttribute('data-value') || secili.textContent || '') : '';
    var ad = 'siyah';
    for (var i = 0; i < RENKLER.length; i++) if (RENKLER[i][0].test(deger)) { ad = RENKLER[i][1]; break; }
    this.sahne.querySelector('[data-mp-cerceve]').setAttribute('data-renk', ad);
  };

  Studyo.prototype.deger = function (q) { var e = this.$(q); return e ? e.value.trim() : ''; };

  Studyo.prototype.durum = function () {
    var f = this.tasarim === 'forever';
    var sb = f && (this.$('[data-mp-fotorenk] input:checked') || {}).value !== 'renkli';
    var palet = null;
    if (!f) {
      if (this.paletSec === 'oto') palet = this.paletler ? this.paletler.oto : null;
      else if (HAZIR_PALET[this.paletSec]) palet = HAZIR_PALET[this.paletSec];
      else if (this.paletler && this.paletler.diger[+this.paletSec]) palet = this.paletler.diger[+this.paletSec];
    }
    var kodVar = !!(this.sarkiBilgi && this.sarkiBilgi.kod);
    return {
      tasarim: this.tasarim,
      isimler: this.deger('[data-mp-isimler]'),
      sarki: this.deger('[data-mp-sarki]'),
      sanatci: this.deger('[data-mp-sanatci]'),
      sureMs: sureOku(this.deger('[data-mp-sure]')),
      tarih: this.deger('[data-mp-tarih]'),
      yil: this.deger('[data-mp-yil]'),
      sozler: f ? this.$('[data-mp-sozler]').value.replace(/\r/g, '') : '',
      gri: sb,
      palet: palet,
      kod: kodVar ? this.sarkiBilgi.kod : null,
      kodGoster: kodVar ? this.$('[data-mp-kod]').checked : null,
      spotify: this.sarkiBilgi ? 'https://open.spotify.com/track/' + this.sarkiBilgi.id : '',
    };
  };

  Studyo.prototype.cizimVerisi = function (d, mod) {
    return Object.assign({}, d, { mod: mod, foto: this.foto, ornek: this.ornek, yerTutucu: this.m.yerTutucu, kodYerTutucu: this.m.kodYerTutucu });
  };

  Studyo.prototype.ciz = function () {
    var d = this.durum();
    posterCiz(this.tuval, this.cizimVerisi(d, 'onizleme'));
    if (this.girdiler && this.gonderilen) this.gonderilen = null; // tasarım değişti: sepete eklerken baskı yeniden hazırlanır
  };

  Studyo.prototype.mesaj = function (t, tur) {
    var p = this.$('[data-mp-mesaj]');
    p.textContent = t || '';
    p.classList.toggle('is-error', tur === 'hata');
  };

  /* ---------- Fotoğraf seçimi, küçük görsel, düzenleme penceresi ---------- */
  Studyo.prototype.fotoSec = async function (dosya) {
    if (!/^image\//.test(dosya.type || 'image/')) { this.mesaj(this.m.acilamadi, 'hata'); return; }
    var a;
    try { a = await resimAc(dosya); } catch (e) { this.mesaj(this.m.acilamadi, 'hata'); return; }
    try {
      this.foto = { dosya: dosya, onizleme: kucukKopya(a.img, 1600), gri: null, iw: a.img.naturalWidth, ih: a.img.naturalHeight, z: 1, cx: 0.5, cy: 0.45, don: 0 };
    } finally {
      URL.revokeObjectURL(a.url);
    }
    this.$('[data-mp-yukle]').hidden = true;
    this.$('[data-mp-yuklu]').hidden = false;
    this.mesaj('');
    this.griHazirla();
    this.paletGuncelle();
    this.kucukCiz();
    this.ciz();
    this.duzenleAc(); // yükleyince fotoğrafın posterde nasıl durduğu hemen gösterilir
  };

  Studyo.prototype.fotoKaldir = function () {
    this.foto = null;
    this.$('[data-mp-yukle]').hidden = false;
    this.$('[data-mp-yuklu]').hidden = true;
    var p = this.$('[data-mp-paletler]');
    if (p) p.hidden = true;
    this.ciz();
  };

  Studyo.prototype.griHazirla = function () {
    if (this.foto && this.tasarim === 'forever' && !this.foto.gri && this.durum().gri) this.foto.gri = griYap(this.foto.onizleme);
  };

  // Küçük görsel (fotoğrafın tamamı, koyu zeminde sığdırılmış) + düşük çözünürlük uyarısı
  Studyo.prototype.kucukCiz = function () {
    var f = this.foto, c = this.$('[data-mp-kucuk]');
    if (!f) return;
    var kaynak = etkinKaynak(f, this.durum().gri), x = c.getContext('2d');
    x.fillStyle = '#111111';
    x.fillRect(0, 0, c.width, c.height);
    var o = Math.min(c.width / kaynak.width, c.height / kaynak.height), w = kaynak.width * o, h = kaynak.height * o;
    x.drawImage(kaynak, (c.width - w) / 2, (c.height - h) / 2, w, h);
    // Baskıda kullanılacak piksel: 50×70 cm'de kutunun genişliği (Spotify ~33,9 cm, Forever ~40,7 cm)
    var kutu = KUTU[this.tasarim], r = kirpHesapla(f, kutu.w / kutu.h), b = etkinBoyut(f);
    var cm = (kutu.w / BW) * 50, dpi = (r.w * b.w) / (cm / 2.54), u = this.$('[data-mp-uyari]');
    u.hidden = dpi >= 90;
    u.textContent = this.m.dusukKalite;
  };

  // Teeinblue tarzı pencere: posterin tamamı; fotoğrafın kutu dışında kalan kısmı soluk, sınırı turkuaz çerçeveyle.
  // Sürükle: taşı · köşe tutamağı / tekerlek / iki parmak: yakınlaştır · düğmeler: yakınlaştır, döndür (90°), kaydır · İptal / Kaydet
  Studyo.prototype.duzenleyiciKur = function () {
    var s = this, m = this.m;
    var ikon = function (d) { return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
    var DUGME = [
      ['uzak', m.uzaklas, ikon('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L20 20M8 10.5h5"/>')],
      ['yakin', m.yakinlas, ikon('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L20 20M8 10.5h5M10.5 8v5"/>')],
      ['sol-don', m.solaDondur, ikon('<path d="M4 4v5h5"/><path d="M4.6 15a8 8 0 1 0 1.9-8.3L4 9"/>')],
      ['sag-don', m.sagaDondur, ikon('<path d="M20 4v5h-5"/><path d="M19.4 15a8 8 0 1 1-1.9-8.3L20 9"/>')],
      ['sol', m.sola, ikon('<path d="M19 12H5M11 6l-6 6 6 6"/>')],
      ['sag', m.saga, ikon('<path d="M5 12h14M13 6l6 6-6 6"/>')],
      ['yukari', m.yukariTasi, ikon('<path d="M12 19V5M6 11l6-6 6 6"/>')],
      ['asagi', m.asagiTasi, ikon('<path d="M12 5v14M6 13l6 6 6-6"/>')],
    ];
    var p = el('div', 'fso-mp-modal');
    p.hidden = true;
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-modal', 'true');
    p.setAttribute('aria-label', m.duzenleBaslik);
    p.innerHTML =
      '<div class="fso-mp-modal-kutu">' +
        '<button type="button" class="fso-mp-modal-kapat" data-mp-iptal>' + ikon('<path d="M6 6l12 12M18 6L6 18"/>') + '</button>' +
        '<p class="fso-mp-modal-baslik"></p>' +
        '<div class="fso-mp-modal-sahne"><canvas class="fso-mp-modal-tuval" data-mp-edit role="img"></canvas></div>' +
        '<div class="fso-mp-arac" role="toolbar">' + DUGME.map(function (d) { return '<button type="button" data-mp-arac="' + d[0] + '" aria-label="' + d[1] + '" title="' + d[1] + '">' + d[2] + '</button>'; }).join('') + '</div>' +
        '<div class="fso-mp-modal-alt"><button type="button" class="fso-mp-iptal" data-mp-iptal></button><button type="button" class="fso-mp-kaydet" data-mp-kaydet></button></div>' +
      '</div>';
    p.querySelector('.fso-mp-modal-baslik').textContent = m.duzenleBaslik;
    p.querySelector('.fso-mp-modal-kapat').setAttribute('aria-label', m.iptal);
    p.querySelector('.fso-mp-iptal').textContent = m.iptal;
    p.querySelector('.fso-mp-kaydet').textContent = m.kaydet;
    p.querySelector('[data-mp-edit]').setAttribute('aria-label', m.duzenleBaslik);
    document.body.appendChild(p);
    this.modal = p;
    this.editTuval = p.querySelector('[data-mp-edit]');
    p.querySelectorAll('[data-mp-iptal]').forEach(function (b) { b.addEventListener('click', function () { s.duzenleKapat(false); }); });
    p.querySelector('[data-mp-kaydet]').addEventListener('click', function () { s.duzenleKapat(true); });
    p.addEventListener('click', function (e) { if (e.target === p) s.duzenleKapat(false); });
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); s.duzenleKapat(false); }
      var ok = { ArrowLeft: 'sol', ArrowRight: 'sag', ArrowUp: 'yukari', ArrowDown: 'asagi' }[e.key];
      if (ok && (e.target === s.editTuval || e.target === s.modalKutu)) { e.preventDefault(); s.arac(ok); }
    });
    p.querySelectorAll('[data-mp-arac]').forEach(function (b) { b.addEventListener('click', function () { s.arac(b.getAttribute('data-mp-arac')); }); });
    this.editTuval.tabIndex = 0;
    this.modalKutu = p.querySelector('.fso-mp-modal-kutu');
    this.modalKutu.tabIndex = -1;
    this.duzenleOlaylari();
    window.addEventListener('resize', function () { if (!p.hidden) s.duzenleCiz(); });
  };

  // Fotoğrafın tamamının poster birimlerindeki dikdörtgeni (kutunun dışına taşan kısım dahil)
  Studyo.prototype.fotoAlani = function () {
    var kutu = KUTU[this.tasarim], r = kirpHesapla(this.foto, kutu.w / kutu.h);
    var w = kutu.w / r.w, h = kutu.h / r.h;
    return { x: kutu.x - r.x * w, y: kutu.y - r.y * h, w: w, h: h, kutu: kutu, r: r };
  };

  Studyo.prototype.duzenleAc = function () {
    if (!this.foto) return;
    this.yedek = { z: this.foto.z, cx: this.foto.cx, cy: this.foto.cy, don: this.foto.don };
    this.oncekiOdak = document.activeElement;
    this.modal.hidden = false;
    document.documentElement.classList.add('fso-mp-kilit');
    this.duzenleCiz();
    this.modalKutu.focus({ preventScroll: true }); // ok tuşları ve Esc çalışsın; tuvalde odak çizgisi görünmesin
  };

  Studyo.prototype.duzenleKapat = function (kaydet) {
    if (this.modal.hidden) return;
    if (!kaydet && this.yedek && this.foto) Object.assign(this.foto, this.yedek);
    this.modal.hidden = true;
    document.documentElement.classList.remove('fso-mp-kilit');
    this.paletGuncelle();
    this.kucukCiz();
    this.ciz();
    if (this.oncekiOdak && this.oncekiOdak.focus) this.oncekiOdak.focus({ preventScroll: true });
  };

  Studyo.prototype.duzenleCiz = function () {
    var c = this.editTuval, f = this.foto;
    if (!f || this.modal.hidden) return;
    var sahne = c.parentNode, en = sahne.clientWidth, boy = sahne.clientHeight;
    var cssW = Math.max(160, Math.min(en, boy * (BW / BH))), cssH = cssW * (BH / BW), dpr = Math.min(2, window.devicePixelRatio || 1);
    c.style.width = cssW + 'px';
    c.style.height = cssH + 'px';
    c.width = Math.round(cssW * dpr);
    c.height = Math.round(cssH * dpr);
    var d = this.durum();
    posterCiz(c, this.cizimVerisi(d, 'onizleme'));
    // Kutunun dışında kalan fotoğraf hiç çizilmez (posterde ne görünecekse o); yalnız sınırı + köşe tutamakları
    var x = c.getContext('2d'), k = c.width / BW, a = this.fotoAlani();
    x.save();
    x.strokeStyle = '#13B5C6';
    x.lineWidth = Math.max(2, 2.2 * dpr);
    x.strokeRect(a.x * k, a.y * k, a.w * k, a.h * k);
    this.tutamaklar = [[a.x, a.y], [a.x + a.w, a.y], [a.x, a.y + a.h], [a.x + a.w, a.y + a.h]];
    this.tutamaklar.forEach(function (t) {
      x.beginPath();
      x.arc(t[0] * k, t[1] * k, 9 * dpr, 0, Math.PI * 2);
      x.fillStyle = '#FFFFFF';
      x.fill();
      x.stroke();
    });
    x.restore();
    // Yakınlaştırma sınırdaysa uzaklaş düğmesi pasif
    this.modal.querySelector('[data-mp-arac="uzak"]').disabled = f.z <= 1.0001;
  };

  // Araç çubuğu: kaydırma adımı kutunun %8'i; yakınlaştırma ×1,12; döndürme 90°
  Studyo.prototype.arac = function (ad) {
    var f = this.foto;
    if (!f) return;
    var a = this.fotoAlani(), adim = 0.08;
    if (ad === 'yakin') this.zoomAyarla(f.z * 1.12);
    else if (ad === 'uzak') this.zoomAyarla(f.z / 1.12);
    else if (ad === 'sol') this.kaydir(-a.kutu.w * adim, 0);
    else if (ad === 'sag') this.kaydir(a.kutu.w * adim, 0);
    else if (ad === 'yukari') this.kaydir(0, -a.kutu.h * adim);
    else if (ad === 'asagi') this.kaydir(0, a.kutu.h * adim);
    else if (ad === 'sag-don' || ad === 'sol-don') {
      // Kırpma merkezi görselle birlikte döner (saat yönünde: (x, y) → (1 − y, x))
      var cx = f.cx, cy = f.cy;
      if (ad === 'sag-don') { f.cx = 1 - cy; f.cy = cx; f.don = (f.don + 1) % 4; } else { f.cx = cy; f.cy = 1 - cx; f.don = (f.don + 3) % 4; }
      this.zoomAyarla(f.z);
    }
    this.duzenleCiz();
    this.ciz();
  };

  // Fotoğrafı poster birimiyle (dx, dy) kaydırır; fotoğraf kutuyu hep doldurur
  Studyo.prototype.kaydir = function (dx, dy) {
    var f = this.foto, a = this.fotoAlani();
    f.cx = sinirla(f.cx - dx / a.w, a.r.w / 2, 1 - a.r.w / 2);
    f.cy = sinirla(f.cy - dy / a.h, a.r.h / 2, 1 - a.r.h / 2);
  };

  Studyo.prototype.zoomAyarla = function (z) {
    var f = this.foto;
    f.z = sinirla(z, 1, 6);
    var r = kirpHesapla(f, KUTU[this.tasarim].w / KUTU[this.tasarim].h);
    f.cx = sinirla(f.cx, r.w / 2, 1 - r.w / 2);
    f.cy = sinirla(f.cy, r.h / 2, 1 - r.h / 2);
  };

  Studyo.prototype.duzenleOlaylari = function () {
    var s = this, c = this.editTuval, dokunus = new Map(), mod = null, ilk = null, cizBekle = false;
    var birim = function (e) { var b = c.getBoundingClientRect(); return { x: ((e.clientX - b.left) / b.width) * BW, y: ((e.clientY - b.top) / b.height) * BH, olcek: b.width / BW }; };
    var guncelle = function () {
      if (cizBekle) return;
      cizBekle = true;
      requestAnimationFrame(function () { cizBekle = false; s.duzenleCiz(); s.ciz(); });
    };
    c.addEventListener('pointerdown', function (e) {
      if (!s.foto) return;
      c.setPointerCapture(e.pointerId);
      var p = birim(e);
      dokunus.set(e.pointerId, p);
      if (dokunus.size === 2) {
        var n = Array.from(dokunus.values());
        mod = 'iki';
        ilk = { mesafe: Math.hypot(n[0].x - n[1].x, n[0].y - n[1].y), z: s.foto.z };
        return;
      }
      // Köşe tutamağı: merkezden uzaklık oranıyla yakınlaştırma; değilse taşıma
      var esik = 16 / p.olcek, a = s.fotoAlani(), merkez = { x: a.x + a.w / 2, y: a.y + a.h / 2 };
      var tut = (s.tutamaklar || []).some(function (t) { return Math.hypot(t[0] - p.x, t[1] - p.y) < esik; });
      mod = tut ? 'kose' : 'tasi';
      ilk = { merkez: merkez, mesafe: Math.max(1, Math.hypot(p.x - merkez.x, p.y - merkez.y)), z: s.foto.z };
    });
    c.addEventListener('pointermove', function (e) {
      var o = dokunus.get(e.pointerId);
      if (!o || !s.foto) return;
      var p = birim(e);
      dokunus.set(e.pointerId, p);
      if (mod === 'iki' && dokunus.size === 2) {
        var n = Array.from(dokunus.values());
        s.zoomAyarla(ilk.z * Math.hypot(n[0].x - n[1].x, n[0].y - n[1].y) / Math.max(1, ilk.mesafe));
      } else if (mod === 'kose') {
        s.zoomAyarla(ilk.z * Math.hypot(p.x - ilk.merkez.x, p.y - ilk.merkez.y) / ilk.mesafe);
      } else if (mod === 'tasi') {
        s.kaydir(p.x - o.x, p.y - o.y);
      }
      guncelle();
    });
    var birak = function (e) { dokunus.delete(e.pointerId); if (!dokunus.size) mod = null; else if (mod === 'iki') mod = null; };
    c.addEventListener('pointerup', birak);
    c.addEventListener('pointercancel', birak);
    c.addEventListener('wheel', function (e) {
      if (!s.foto) return;
      e.preventDefault();
      s.zoomAyarla(s.foto.z * (e.deltaY < 0 ? 1.08 : 1 / 1.08));
      guncelle();
    }, { passive: false });
  };

  /* ---------- Spotify zemin renkleri ---------- */
  Studyo.prototype.paletGuncelle = function () {
    if (this.tasarim !== 'spotify' || !this.foto) return;
    var kutu = KUTU.spotify;
    this.paletler = renkCikar(etkinKaynak(this.foto, false), kirpHesapla(this.foto, kutu.w / kutu.h));
    var s = this, kutuEl = this.$('[data-mp-renkler]');
    kutuEl.innerHTML = '';
    var secenekler = [{ id: 'oto', ad: this.m.renkOto, p: this.paletler.oto }]
      .concat(this.paletler.diger.map(function (p, i) { return { id: String(i), ad: p.ad, p: p }; }))
      .concat([{ id: 'yesil', ad: HAZIR_PALET.yesil.ad, p: HAZIR_PALET.yesil }, { id: 'kahve', ad: HAZIR_PALET.kahve.ad, p: HAZIR_PALET.kahve }]);
    if (!secenekler.some(function (x) { return x.id === s.paletSec; })) this.paletSec = 'oto';
    secenekler.forEach(function (x) {
      var b = el('button', 'fso-mp-renk');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(x.id === s.paletSec));
      b.setAttribute('aria-label', x.ad);
      b.title = x.ad;
      b.style.background = 'linear-gradient(135deg, ' + x.p.isik + ' 0%, ' + x.p.taban + ' 62%, ' + x.p.derin + ' 100%)';
      if (x.id === 'oto') b.appendChild(el('span', 'fso-mp-renk-oto', 'A'));
      b.addEventListener('click', function () {
        s.paletSec = x.id;
        kutuEl.querySelectorAll('.fso-mp-renk').forEach(function (y) { y.setAttribute('aria-checked', String(y === b)); });
        s.ciz();
      });
      kutuEl.appendChild(b);
    });
    this.$('[data-mp-paletler]').hidden = false;
  };

  /* ---------- Spotify ve sözler ---------- */
  Studyo.prototype.istek = async function (yol, secenek) {
    var r = await fetch(this.api + yol, secenek || {});
    var veri = await r.json().catch(function () { return {}; });
    if (!r.ok) { var h = new Error(veri.hata || this.m.baskiHata); h.sunucu = !!veri.hata; throw h; }
    return veri;
  };

  /* ---------- Şarkı arama (albüm kapağı ürünündeki gibi) ----------
     Yazdıkça /spotify/ara'dan şarkılar listelenir; seçilen şarkı spotifyAl ile alanlara dolar.
     Spotify linki yapıştırılırsa arama yapılmadan doğrudan çözülür. */
  var LINK = /(open\.spotify\.com|spotify:track:|spotify\.link\/|spoti\.fi\/)/i;
  Studyo.prototype.aramaKur = function () {
    var s = this, girdi = this.$('[data-mp-spotify]'), sil = this.$('[data-mp-ara-sil]'), liste = this.$('[data-mp-sonuclar]'), bekle;
    sil.setAttribute('aria-label', this.m.araSil);
    this.sonuclar = [];
    this.aktif = -1;
    var yaz = function () {
      clearTimeout(bekle);
      s.araSira = (s.araSira || 0) + 1; // yoldaki eski arama sonucu artık gösterilmesin
      s.araDonuyor(false);
      var v = girdi.value.trim();
      if (!v) { s.sonucKapat(); s.spotifyAl(''); return; }
      if (v === s.araEtiket) return; // seçimden sonra kutuya yazılan "şarkı – sanatçı"
      if (LINK.test(v) || /^[A-Za-z0-9]{22}$/.test(v)) { s.sonucKapat(); bekle = setTimeout(function () { s.spotifyAl(v); }, 350); return; }
      bekle = setTimeout(function () { s.sarkiAra(v); }, 320);
    };
    girdi.addEventListener('input', yaz);
    girdi.addEventListener('keydown', function (e) {
      var acik = !liste.hidden && s.sonuclar.length;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!acik) return;
        e.preventDefault();
        s.aktifYap((s.aktif + (e.key === 'ArrowDown' ? 1 : -1) + s.sonuclar.length) % s.sonuclar.length);
      } else if (e.key === 'Enter') {
        e.preventDefault(); // ürün formu gönderilmesin
        if (acik) s.sarkiSec(s.sonuclar[s.aktif >= 0 ? s.aktif : 0]);
        else { clearTimeout(bekle); var v = girdi.value.trim(); if (v && v !== s.araEtiket) (LINK.test(v) ? s.spotifyAl(v) : s.sarkiAra(v)); }
      } else if (e.key === 'Escape' && acik) {
        e.preventDefault();
        s.sonucKapat();
      }
    });
    girdi.addEventListener('focus', function () { if (s.sonuclar.length && girdi.value.trim() === s.sonAranan) s.sonucGoster(); });
    sil.addEventListener('click', function () { girdi.value = ''; s.araEtiket = null; yaz(); girdi.focus(); });
    liste.addEventListener('mousedown', function (e) { e.preventDefault(); }); // seçerken kutu odağını kaybetmesin
    liste.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('[data-i]');
      if (li) s.sarkiSec(s.sonuclar[Number(li.getAttribute('data-i'))]);
    });
    document.addEventListener('pointerdown', function (e) {
      if (!liste.hidden && !(e.target.closest && e.target.closest('[data-mp-ara-alan]') === s.$('[data-mp-ara-alan]'))) s.sonucKapat();
    });
    this.$('[data-mp-secili-degistir]').addEventListener('click', function () { girdi.focus(); girdi.select(); });
  };

  Studyo.prototype.araDonuyor = function (evet) {
    this.$('[data-mp-ara-donen]').hidden = !evet;
    this.$('[data-mp-ara-sil]').hidden = evet || !this.$('[data-mp-spotify]').value.trim();
  };

  Studyo.prototype.sarkiAra = async function (q) {
    var durum = this.$('[data-mp-spotify-durum]');
    if (q.length < 2) { this.sonucKapat(); return; }
    var sira = (this.araSira = (this.araSira || 0) + 1);
    this.araDonuyor(true);
    var r;
    try {
      r = await this.istek('/spotify/ara?q=' + encodeURIComponent(q));
    } catch (e) {
      if (sira !== this.araSira) return;
      this.araDonuyor(false);
      this.sonucKapat();
      durum.textContent = e && e.sunucu ? e.message : this.m.araHata;
      durum.classList.add('is-error');
      return;
    }
    if (sira !== this.araSira) return;
    this.araDonuyor(false);
    this.sonAranan = q;
    this.sonuclar = r.sonuclar || [];
    durum.classList.remove('is-error');
    if (!this.sonuclar.length) { this.sonucKapat(); durum.textContent = this.m.araYok; return; }
    durum.textContent = '';
    var liste = this.$('[data-mp-sonuclar]'), kimlikOn = liste.id;
    liste.innerHTML = '';
    this.sonuclar.forEach(function (it, i) {
      var li = el('li', 'fso-mp-sonuc');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-i', String(i));
      li.id = kimlikOn + '-' + i;
      if (it.kapak) { var img = document.createElement('img'); img.src = it.kapak; img.alt = ''; img.width = 46; img.height = 46; li.appendChild(img); }
      else li.appendChild(el('span', 'fso-mp-sonuc-bos'));
      var yazi = el('span', 'fso-mp-sonuc-yazi');
      var ad = el('span', 'fso-mp-sonuc-ad'); ad.textContent = it.ad;
      var alt = el('span', 'fso-mp-sonuc-alt'); alt.textContent = it.sanatci + (it.yil ? ' · ' + it.yil : '');
      yazi.appendChild(ad); yazi.appendChild(alt); li.appendChild(yazi);
      var sure = el('span', 'fso-mp-sonuc-sure'); sure.textContent = it.sure || ''; li.appendChild(sure);
      liste.appendChild(li);
    });
    this.sonucGoster();
  };

  Studyo.prototype.sonucGoster = function () {
    var liste = this.$('[data-mp-sonuclar]');
    liste.hidden = false;
    liste.scrollTop = 0;
    this.$('[data-mp-spotify]').setAttribute('aria-expanded', 'true');
    this.aktifYap(-1);
  };

  Studyo.prototype.sonucKapat = function () {
    var liste = this.$('[data-mp-sonuclar]'), girdi = this.$('[data-mp-spotify]');
    liste.hidden = true;
    girdi.setAttribute('aria-expanded', 'false');
    girdi.removeAttribute('aria-activedescendant');
    this.aktif = -1;
  };

  Studyo.prototype.aktifYap = function (i) {
    var liste = this.$('[data-mp-sonuclar]'), girdi = this.$('[data-mp-spotify]');
    this.aktif = i;
    Array.prototype.forEach.call(liste.children, function (li, j) {
      li.classList.toggle('is-aktif', j === i);
      li.setAttribute('aria-selected', j === i ? 'true' : 'false');
      if (j === i && li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
    });
    if (i >= 0) girdi.setAttribute('aria-activedescendant', liste.id + '-' + i); else girdi.removeAttribute('aria-activedescendant');
  };

  Studyo.prototype.sarkiSec = function (it) {
    if (!it) return;
    this.sonucKapat();
    var girdi = this.$('[data-mp-spotify]');
    this.araEtiket = it.ad + ' – ' + it.sanatci;
    girdi.value = this.araEtiket;
    this.$('[data-mp-ara-sil]').hidden = false;
    this.spotifyAl('spotify:track:' + it.id, it);
  };

  Studyo.prototype.seciliGoster = function (b) {
    var kutu = this.$('[data-mp-secili]');
    if (!b) { kutu.hidden = true; return; }
    var img = this.$('[data-mp-secili-kapak]');
    img.hidden = !b.kapak;
    if (b.kapak) img.src = b.kapak;
    this.$('[data-mp-secili-ad]').textContent = b.ad;
    this.$('[data-mp-secili-alt]').textContent = b.sanatci + (b.sure ? ' · ' + b.sure : '');
    kutu.hidden = false;
  };

  // Link/kimlik → şarkı adı, sanatçı, süre (alanlara yazılır, düzenlenebilir), Spotify kodu; Forever'da sözler
  Studyo.prototype.spotifyAl = async function (deger, onBilgi) {
    var v = String(deger || '').trim(), durum = this.$('[data-mp-spotify-durum]'), f = this.tasarim === 'forever';
    if (this.sarkiBilgi && this.sarkiBilgi.girdi === v) return;
    var sira = (this.spotifySira = (this.spotifySira || 0) + 1);
    durum.classList.remove('is-error');
    var kodKutu = this.$('[data-mp-kod]');
    if (!v) {
      this.sarkiBilgi = null;
      kodKutu.disabled = true;
      this.seciliGoster(null);
      durum.textContent = f ? this.m.spotifyYardimForever : this.m.spotifyYardim;
      this.ciz();
      return;
    }
    durum.textContent = this.m.spotifyAraniyor;
    this.araDonuyor(true);
    try {
      var b = await this.istek('/spotify?u=' + encodeURIComponent(v));
      var kod = await kodAl(b.kod);
      if (sira !== this.spotifySira) return;
      this.sarkiBilgi = { girdi: v, id: b.id, ad: b.ad, sanatci: b.sanatci, sanatcilar: b.sanatcilar || [], sureMs: b.sureMs, sure: b.sure, kod: kod };
      this.$('[data-mp-sarki]').value = b.ad || '';
      this.$('[data-mp-sanatci]').value = b.sanatci || '';
      var sureG = this.$('[data-mp-sure]');
      if (sureG) sureG.value = b.sure || '';
      kodKutu.disabled = false;
      kodKutu.checked = true;
      this.araDonuyor(false);
      this.seciliGoster({ ad: b.ad, sanatci: b.sanatci, sure: b.sure, kapak: b.kapak || (onBilgi && onBilgi.kapak) });
      durum.textContent = '';
      // Link yapıştırıldıysa kutuda şarkının adı görünsün
      var girdi = this.$('[data-mp-spotify]');
      if (LINK.test(girdi.value) || /^[A-Za-z0-9]{22}$/.test(girdi.value.trim())) { this.araEtiket = b.ad + ' – ' + b.sanatci; girdi.value = this.araEtiket; }
      if (f) this.sozAl(b, sira);
    } catch (e) {
      if (sira !== this.spotifySira) return;
      console.warn('[muzik] spotify', e);
      this.araDonuyor(false);
      this.seciliGoster(null);
      this.sarkiBilgi = null;
      kodKutu.disabled = true;
      durum.textContent = e && e.sunucu ? e.message : this.m.spotifyHata;
      durum.classList.add('is-error');
    }
    this.ciz();
  };

  Studyo.prototype.sozAl = async function (b, sira) {
    var s = this, kutu = this.$('[data-mp-soz]'), liste = this.$('[data-mp-soz-liste]'), durum = this.$('[data-mp-soz-durum]');
    kutu.hidden = true;
    durum.hidden = false;
    durum.textContent = this.m.sozAraniyor;
    var r, yol = '/muzik/soz?ad=' + encodeURIComponent(b.ad) + '&sanatci=' + encodeURIComponent((b.sanatcilar && b.sanatcilar[0]) || b.sanatci || '') + '&sure=' + Math.round((b.sureMs || 0) / 1000);
    for (var deneme = 0; deneme < 2; deneme++) {
      try {
        r = await this.istek(yol);
      } catch (e) {
        r = { satirlar: [], gecici: true };
      }
      if (!r.gecici || sira !== this.spotifySira) break;
      await new Promise(function (t) { setTimeout(t, 1200); }); // söz servisi geç kaldıysa bir kez daha
    }
    if (sira !== this.spotifySira) return;
    var satirlar = (r.satirlar || []);
    if (!satirlar.some(Boolean)) { durum.textContent = this.m.sozYok; return; }
    durum.hidden = true;
    liste.innerHTML = '';
    var secili = [];
    var yaz = function () {
      var t = liste.querySelectorAll('input:checked');
      Array.prototype.forEach.call(liste.querySelectorAll('input'), function (i) { i.disabled = !i.checked && t.length >= 4; });
      s.$('[data-mp-sozler]').value = Array.prototype.map.call(t, function (i) { return i.value; }).join('\n');
      s.sozOto = true;
      s.ciz();
    };
    satirlar.forEach(function (satir) {
      if (!satir) { liste.appendChild(el('span', 'fso-mp-soz-ara')); return; }
      var l = el('label', 'fso-mp-soz-satir'), i = document.createElement('input');
      i.type = 'checkbox';
      i.value = satir;
      if (secili.length < 4) { i.checked = true; secili.push(satir); }
      i.addEventListener('change', yaz);
      l.appendChild(i);
      l.appendChild(el('span', null)).textContent = satir;
      liste.appendChild(l);
    });
    kutu.hidden = false;
    // Müşteri sözleri kendisi yazdıysa üzerine yazılmaz; boşsa ya da önceki şarkıdan geldiyse ilk dört satır gelir
    var alan = this.$('[data-mp-sozler]');
    if (!alan.value.trim() || this.sozOto) yaz();
    else Array.prototype.forEach.call(liste.querySelectorAll('input'), function (i) { i.checked = false; i.disabled = false; });
  };

  Studyo.prototype.polaroidSec = function (dosya) {
    this.polaroid = dosya && /^image\//.test(dosya.type || 'image/') ? dosya : null;
    this.$('[data-mp-polaroid-ad]').textContent = this.polaroid ? this.polaroid.name : this.m.polaroidSec;
    this.$('[data-mp-polaroid-kaldir]').hidden = !this.polaroid;
    this.gonderilen = null;
  };

  /* ---------- Sepete ekleme: baskı dosyası ---------- */
  Studyo.prototype.ozellikYaz = function (d, r) {
    var g = this.girdiler, ata = function (ad, v) { if (g[ad]) g[ad].value = v || ''; };
    ata('_tasarim', TASARIM[this.tasarim].ad);
    ata('_tasarim_pdf', r.pdf);
    ata('_tasarim_onizleme', r.onizleme);
    ata('_foto', r.foto);
    ata('_polaroid', r.polaroid);
    ata('_sarki', d.sarki);
    ata('_sanatci', d.sanatci);
    ata('_spotify', d.kodGoster ? d.spotify : (d.spotify ? d.spotify + ' (kod istenmedi)' : ''));
    ata('_isimler', d.isimler);
    ata('_sure', d.sureMs ? sureYaz(d.sureMs) : '');
    ata('_zemin_rengi', d.palet ? d.palet.ad + ' ' + d.palet.taban + ' / ' + d.palet.isik : '');
    ata('_tarih', d.tarih);
    ata('_yil', d.yil);
    ata('_sozler', String(d.sozler || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean).join(' / '));
    ata('_foto_rengi', d.gri ? 'Siyah-beyaz' : 'Renkli');
  };

  Studyo.prototype.gonderiliyor = function (e, dugme) {
    if (this.gecis) return;
    var durdur = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (this.gonderiyor) { durdur(); return; }
    if (!this.foto) { durdur(); this.mesaj(this.m.once, 'hata'); this.goster(); return; }
    var d = this.durum();
    if (this.tasarim === 'spotify' && !d.sarki) { durdur(); this.mesaj(this.m.sarkiOnce, 'hata'); this.goster(); this.$('[data-mp-spotify]').focus({ preventScroll: true }); return; }
    var anahtar = JSON.stringify([d, this.foto.z, this.foto.cx, this.foto.cy, this.foto.don, this.foto.dosya.name, this.foto.dosya.size, this.polaroid && this.polaroid.size]);
    if (this.gonderilen === anahtar && this.girdiler._tasarim_pdf.value) return; // aynı tasarım zaten hazır
    durdur();
    this.baskiGonder(anahtar, d, dugme || this.form.querySelector('button[type="submit"]'));
  };

  function tuvalBlob(c, q) { return new Promise(function (tamam) { c.toBlob(tamam, 'image/jpeg', q); }); }

  // XHR ile gönderim (fotoğraf büyük olabilir: yükleme yüzdesi gösterilir)
  Studyo.prototype.gonder = function (fd, ilerleme) {
    var s = this;
    return new Promise(function (tamam, red) {
      var x = new XMLHttpRequest();
      x.open('POST', s.api + '/muzik/baski');
      x.responseType = 'json';
      x.upload.onprogress = function (e) { if (e.lengthComputable) ilerleme(e.loaded / e.total); };
      x.onload = function () {
        var v = x.response || {};
        if (x.status >= 200 && x.status < 300 && v.pdf) tamam(v);
        else { var h = new Error(v.hata || s.m.baskiHata); h.sunucu = !!v.hata; red(h); }
      };
      x.onerror = function () { red(new Error(s.m.baskiHata)); };
      x.send(fd);
    });
  };

  Studyo.prototype.baskiGonder = async function (anahtar, d, dugme) {
    var s = this;
    this.gonderiyor = true;
    this.mesaj(this.m.baskiHazirlaniyor);
    if (dugme) { dugme.disabled = true; dugme.setAttribute('aria-busy', 'true'); }
    try {
      await yaziTipleriniYukle();
      // 1) Fotoğraf hariç poster (zemin), yüksek çözünürlük; tuval açılamazsa küçült
      var zemin = null;
      for (var o = 1; o >= 0.6 && !zemin; o -= 0.2) {
        var c = document.createElement('canvas');
        c.width = Math.round(BASKI[0] * o); c.height = Math.round(BASKI[1] * o);
        posterCiz(c, this.cizimVerisi(d, 'zemin'));
        zemin = await tuvalBlob(c, 0.92);
        c.width = c.height = 1;
      }
      if (!zemin) throw new Error('zemin oluşturulamadı');
      // 2) Sipariş için küçük önizleme (fotoğraflı)
      var k = document.createElement('canvas');
      k.width = 600; k.height = 840;
      posterCiz(k, this.cizimVerisi(d, 'tam'));
      var kucuk = await tuvalBlob(k, 0.85);
      // 3) Fotoğraf: JPEG ise kendisi; siyah-beyaz vb. ise yeniden kodlanmış hâli
      var foto = await baskiFotosu(this.foto.dosya, d.gri);
      var kutu = KUTU[this.tasarim];
      var fd = new FormData();
      fd.append('zemin', zemin, 'zemin.jpg');
      fd.append('foto', foto, 'foto.jpg');
      fd.append('onizleme', kucuk, 'onizleme.jpg');
      if (this.polaroid) fd.append('polaroid', this.polaroid, this.polaroid.name || 'polaroid.jpg');
      fd.append('yerlesim', JSON.stringify({ tasarim: this.tasarim, kirp: kirpHesapla(this.foto, kutu.w / kutu.h), don: this.foto.don }));
      var r = await this.gonder(fd, function (oran) { s.mesaj(s.m.yukleniyor + ' %' + Math.round(oran * 100)); });
      this.ozellikYaz(d, r);
      this.gonderilen = anahtar;
      this.mesaj('');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
      this.gecis = true;
      try { if (dugme) dugme.click(); else s.form.requestSubmit(); } finally { this.gecis = false; }
    } catch (e) {
      console.warn('[muzik] baskı', e);
      this.mesaj(e && e.sunucu ? e.message : this.m.baskiHata, 'hata');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
    } finally {
      this.gonderiyor = false;
    }
  };

  Studyo.prototype.goster = function () {
    var kart = this.kok.closest('[data-fso-custom]') || this.kok;
    var ofset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fso-header-sticky-h'), 10) || 0;
    window.scrollTo({ top: Math.max(0, kart.getBoundingClientRect().top + window.scrollY - ofset - 12), behavior: 'smooth' });
    kart.classList.remove('is-need');
    void kart.offsetWidth;
    kart.classList.add('is-need');
  };

  function baslat() {
    document.querySelectorAll('[data-fso-muzik]').forEach(function (k) {
      if (k.__fsoMuzik) return;
      k.__fsoMuzik = new Studyo(k);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  window.FsoMuzikPoster = { baslat: baslat, posterCiz: posterCiz, renkCikar: renkCikar, KUTU: KUTU };
})();
